/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'ai-mate.chat-error-banner.description': 'Vaše historie chatu je uložena na 30 dní.',
  'ai-mate.chat-error-banner.title': 'Zahájit nový chat',
  'ai-mate.chat-error.description': 'Zkuste <btn>znovu načíst chat</btn>.',
  'ai-mate.chat-error.rate-limited-description': 'Dosáhli jste maximálního počtu žádostí. Zkuste to znovu později.',
  'ai-mate.chat-error.rate-limited-title': 'Příliš mnoho žádostí',
  'ai-mate.chat-error.rovo-inactive-description':
    'Zdá se, že nástroj Rovo není na vašem webu zapnutý. <link>Nastavení nástroje Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Nástroj Rovo není aktivní',
  'ai-mate.chat-error.title': 'Nejsme si jistí, kde se stala chyba',
  'conversation-assistant-button.label': 'Chat',
  'conversation-assistant-button.rovo-chat-label': 'Chat Rovo',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Zeptejte se na to AI.',
  'highlight-actions.rovo-chat-explain-option.text': 'Vysvětlit',
  'highlight-actions.rovo-chat-explain-prompt': 'Vysvětlete toto: {selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Doporučení chatu',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Otevřít chat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Shrnout',
  'highlight-actions.rovo-chat-summarize-prompt': 'Shrňte toto: {selectedText}',
  'highlight-actions.rovo-chat.button-text': 'Chat',
  'horizontal-scroll-container.scroll-left': 'Posunout doleva',
  'horizontal-scroll-container.scroll-right': 'Posunout doprava',
};
